
import React from "react";

import { ListContentsProps, ListContentsState } from "./models";

import { 
    Box, 
    Button, 
    Stack, 
    Typography 
} from "@mui/material";

import Masonry from '@mui/lab/Masonry';

import { Trans } from "@lingui/macro";
import { ContentEnduserService } from "services/content-enduser-service";

import { ContentPreviewElement } from "components/content-preview-element/content-preview-element";
import ZPlayLoader from "commons/zplay-loader";

export class ListContents extends React.Component<ListContentsProps, ListContentsState> {

    constructor(props: any) {
        super(props);

        this.state = {
            searchText: "",
            contents: [],
            hasMorePages: false,
            pageSize: 12,
            loaded: false,
            pageId: 0
        }
    }

    componentDidMount(): void {
        this.getContents();
    }

    private incrementPageNumber = () => {
        this.setState({ pageId: this.state.pageId + 1 }, () => this.getContents());
    }

    private getContentsSuccessCb = (data: any) => {

        let oldContentList = this.state.contents;

        if (!oldContentList)
            oldContentList = []

        oldContentList = oldContentList.concat(data.list);

        this.setState(() => ({ contents: oldContentList, loaded: true }));
    }

    private getContentsErrorCb = (err: any) => {

    }

    private getContents = () => {

        let request = {
            pageId: this.state.pageId + 1,
            pageSize: this.state.pageSize,
            searchText: this.state.searchText
        }

        ContentEnduserService.getFilteredContentList(request, this.getContentsSuccessCb, this.getContentsErrorCb)
    }

    render() {
        return (<>
            {!this.state.loaded && <ZPlayLoader />}
            {this.state.loaded && <Box sx={{ p: 5 }}>
                <Stack alignContent={"center"} >
                    <Typography variant="h2" sx={{ textAlign: "center", color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }}>
                        <Trans id="lc-title"> Contenuti </Trans>
                    </Typography>
                    <Masonry spacing={10} sx={{ margin: "auto" }}>
                        {this.state.contents.map((item, index) => (
                            <ContentPreviewElement hasHorizontalMargin={false} content={item} key={item.id} overlayId={'overlay' + item.id} />
                        ))}
                    </Masonry>
                    <Button variant="contained"
                        onClick={() => this.incrementPageNumber()}
                        color={"secondary"}
                        size={"large"}
                        sx={{
                            textTransform: "none",
                        }}>
                        <Trans id="lc-load-more">Carica altro</Trans>
                    </Button>
                </Stack>
            </Box>}
        </>);
    }
}